const PHONE_RE = /^\+\d{8,15}$/;
const OTP_RE = /^\d{6}$/;

export const normalizePhone = (value = "") => {
  const compact = value.replace(/[\s()-]/g, "");
  if (compact.startsWith("+410")) {
    return `+41${compact.slice(4)}`;
  }
  return compact;
};

export const validatePhoneForOtp = (value, t) => {
  const normalized = normalizePhone(value);
  if (!normalized) {
    return t("errors.phoneRequired");
  }
  if (!PHONE_RE.test(normalized)) {
    return t("errors.phoneInvalid");
  }
  return "";
};

export const validateOtpCode = (value, t) => {
  const normalized = (value || "").replace(/\D/g, "");
  if (!normalized) {
    return t("errors.otpRequired");
  }
  if (!OTP_RE.test(normalized)) {
    return t("errors.otpInvalid");
  }
  return "";
};
